<template>
  <div>
    <!-- 顶部banner -->
    <banner :image="require(`@/assets/solution/banner4.jpg`)"  :fontText="fontText" />
    <!-- 一 -->
    <div class="floor-shopping floor-tab-height1350">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            社交电商：机遇与挑战并存，市场规模过万亿
          </div>
        </div>
        <div class="retailForEach" data-aos="fade-up">
          <div class="shopping-opportunity">
            <div class="shopping-container-title">
              机遇
            </div>
            <div class="shopping-container-cont">
              据相关数据显示，2017年社交电商行业市场规模达到6835.8亿元，2018年社交电商行业市场规模突破万亿元；未来3年行业将有10倍以上的拓展空间。
            </div>
            <div class="shopping-opportunity-tips">
              2015年-2020年<br/>
              我国社交电商用户规模情况
            </div>
            <img src="@/assets/solution/shopNum1.png" alt="">
          </div>
          <div class="shopping-Challenge">
            <div class="shopping-container-title">
              挑战
            </div>
            <div class="shopping-container-cont" style="text-align: center;">
              打破传统，顺应时代趋势，意味着企业转型已迫在眉睫。
            </div>
            <div class="shopping-Challenge-position shoppingPosition1">
              了解社交电商的重要性，但无奈对行业一窍不通
            </div>
            <div class="shopping-Challenge-position shoppingPosition2">
              没有专业团队建设管理，投资风险高
            </div>
            <div class="shopping-Challenge-position shoppingPosition3">
              没有专业人员运营管理，缺乏落地运营方案
            </div>
            <div class="shopping-Challenge-position shoppingPosition4">
              市面上系统服务商只提供系统工具，<br/>无法很好契合自身项目发展需求
            </div>
          </div>
        </div>
        <div data-aos="fade-up">
          <div class="title">
            玩转主流的社交电商模式
          </div>
        </div>
        <div class="retailForEach" data-aos="fade-up">
          <div class="shop-item" v-for="(item,index) in shopList" :key="index">
            <div class="shop-item-title">{{ item.title }}</div>
            <div class="shop-item-content">{{item.content}}</div>
            <div class="shop-item-content-forEach">
              <div class="shop-item-forEach-item" v-for="(item2,index2) in item.iconArr" :key="index2">
                <img :src="item2.icon" alt="">
                <div class="shop-item-forEach-font">{{item2.text}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 二 -->
    <div class="floor-shopping-bg floor-tab-height750">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            多种营销功能玩转社交裂变
          </div>
        </div>
        <div class="retailForEach" style="flex-wrap: wrap;" data-aos="fade-up">
          <div v-for="(item,index) in shoppingTwoList" :key="index" class="shopping-item-three">
            <img :src="item.icon" alt="">
            <div class="shopping-item-three-title">{{item.title}}</div>
            <div class="shopping-item-three-content" v-html="item.content"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 三 -->
     <div class="floor-shopping floorBg floor-tab-height950">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            解锁多种分享模式
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            鼓励会员主动分享传播，吸引新用户，培养老用户的消费习惯，提升忠诚度，一次锁定会员多次盈利，提升商城复购率
          </div>
        </div>
        <div class="shop-tab-container" data-aos="fade-up">
          <div v-for="(item,index) in tabList" :key="index" @click="selectIndex=item.value" :class="{'active':selectIndex===item.value}" class="shop-tab-item">
            {{
              item.name
            }}
          </div>
        </div>
        <div v-for="(item, index) in shopTabList" :key="index" style="margin-top:25px" >
          <div v-if="selectIndex===index" class="shop-tab-foreach">
            <div  class="shop-tab-item-left">
              <div class="shop-tab-item-title" v-if="item.title">
                {{item.title}}
              </div>
              <div class="shop-tab-item-content" v-if="item.content">
                {{item.content}}
              </div>
            </div>
            <div class="shop-tab-item-right">
              <img :src="item.image" alt="">
              <div class="shop-tab-item-font" v-if="item.bottomTitle">
                <div class="shop-tab-item-font-title" v-html="item.bottomTitle"></div>
                <div class="shop-tab-item-font-cont">{{item.bottomContent}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 四 -->
    <div class="floor-shopping floor-tab-height1000">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            依托朋友圈口碑传播，建立个性化电商品牌
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            利用碎片时间，通过商品海报、分销海报、关注海报多种海报玩法，借助微信朋友圈10亿强大的社交网络，帮助您推广、吸粉、宣传商品
          </div>
        </div>
        <div class="shop-flex-container" data-aos="fade-up">
          <div  class="shop-flex-container-item">
            <img src="@/assets/solution/shopNum2.jpg" alt="" />
            <div class="shop-flex-container-title">商品海报-帮助商城宣传商品</div>
          </div>
          <div  class="shop-flex-container-item">
            <img src="@/assets/solution/shopNum3.jpg" alt="" />
            <div class="shop-flex-container-title">分销海报-发展下线全民分销</div>
          </div>
          <div  class="shop-flex-container-item">
            <img src="@/assets/solution/shopNum4.jpg" alt="" />
            <div class="shop-flex-container-title">关注海报-吸引粉丝关注商城</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 五 -->
    <div class="floor-shopping floorColor floor-tab-height840">
      <div>
        <div data-aos="fade-up">
          <div class="title">
            全方位运营服务体系 助力成功
          </div>
          <div style="font-size: 16px; color: #595859; line-height: 21px">
            不仅仅提供系统，我们提供一体化的运营解决方案
          </div>
        </div>
        <div class="shopping-content" data-aos="fade-up">
          <div v-for="(item,index) in shopThrList" :key="index" class="shopping-item-two" :style="{ background: `url(${item.image}) no-repeat`, backgroundSize: '100% 100%' }">
            <div class="shopping-two-title">{{item.title}}</div>
            <div class="shopping-two-content">{{item.content}}</div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Footer from '../../components/Footer'
import banner from './components/banner'
import floorTwo from './components/floor2'

export default {
  name: "shopping",
  components: {
    floorTwo,
    Footer,
    banner
  },
  data() {
    return {
      fontText: {
        title: '社交电商解决方案',
        txtMiddle: [
          '掘金社交电商，拥抱社交营销新趋势',
          '多种营销玩法盘活私域流量',
          '实现获客、转化、裂变'
        ]
      },
      shopList: [
        {
          iconArr: [
            {
              icon: require("@/assets/solution/shopIcon1.png"),
              text: '拼多多'
            },
            {
              icon: require("@/assets/solution/shopIcon2.png"),
              text: '苏宁拼购'
            },
            {
              icon: require("@/assets/solution/shopIcon3.png"),
              text: '京东拼购'
            },
          ],
          title: '拼团砍价模式',
          content: '拼多多崛起后，带动了主流电商平台也开启了拼团砍价模式，通过微信的社交优势，开启多人拼团，结合全民砍价，“砍一刀”快速传播分享'
        },
        {
          iconArr: [
            {
              icon: require("@/assets/solution/shopIcon4.png"),
              text: '云集'
            },
            {
              icon: require("@/assets/solution/shopIcon5.png"),
              text: '未来集市'
            },
            {
              icon: require("@/assets/solution/shopIcon6.png"),
              text: '顺联动力'
            },
          ],
          title: '会员制分销模式',
          content: '云集模式的成功，将分销与会员的社交电商模式带来了一个全新的玩法，用户通过开通会员获得分享权益，推荐更多会员享受提成'
        },
        {
          iconArr: [
            {
              icon: require("@/assets/solution/shopIcon7.png"),
              text: '小红书'
            },
            {
              icon: require("@/assets/solution/shopIcon8.png"),
              text: '蘑菇街'
            },
            {
              icon: require("@/assets/solution/shopIcon9.png"),
              text: '值得买'
            },
          ],
          title: '内容电商模式',
          content: '通过长文章内容模式，引入商品介绍分享使用心得，同时关联商品购买地址带动商品销售'
        },
      ],
      shoppingTwoList: [
        {
          icon: require("@/assets/solution/shopIcon11.png"),
          title: '多人拼团',
          content: '<span>基于微信社交的拼团<br/>开团后邀请好友成团</span>'
        },
        {
          icon: require("@/assets/solution/shopIcon12.png"),
          title: '砍价活动',
          content: '<span>分享“帮忙砍一刀”<br/>微信内互动交流砍价</span>'
        },
        {
          icon: require("@/assets/solution/shopIcon13.png"),
          title: '商品分享传播',
          content: '<span>通过社会化分享<br/>将商品直接对外传播</span>'
        },
        {
          icon: require("@/assets/solution/shopIcon14.png"),
          title: '专属推广海报',
          content: '<span>会员邀请好友时<br/>自动生成精美推广海报</span>'
        },
        {
          icon: require("@/assets/solution/shopIcon15.png"),
          title: '分销会员管理',
          content: '<span>会员可以随时查看<br/>下级会员列表及贡献详情</span>'
        },
        {
          icon: require("@/assets/solution/shopIcon16.png"),
          title: '分销佣金明细',
          content: '<span>查看下级会员每笔订单<br/>是否分成的佣金明细</span>'
        },
        {
          icon: require("@/assets/solution/shopIcon17.png"),
          title: '公众号营销',
          content: '<span>吸引用户关注<br/>定期推送平台活动消息</span>'
        },
        {
          icon: require("@/assets/solution/shopIcon18.png"),
          title: '社区圈子互动',
          content: '<span>发布资讯关联商品<br/>打造内容电商模式</span>'
        },
      ],
      selectIndex: 0,
      tabList: [
        {
          value: 0,
          name: '分享模式'
        },
        {
          value: 1,
          name: '分享渠道'
        },
        {
          value: 2,
          name: '激励规则'
        },
      ],
      shopTabList: [
        {
          title: '打造创新社交分销模式',
          content: '融合拼团、分销、信息流等多种前沿社交营销模式，引爆流量，搭建以人为中心的社交电商解决方案',
          image: require("@/assets/solution/shopOne.png"),
        },
        {
          title: '快速搭建分销渠道',
          content: '搭建小程序+公众号+微商城+APP的一体化分销渠道，魔方建站体系，多样化组件任意拖拽，无需美工，快速搭建企业专属分销商城',
          image: require("@/assets/solution/shopTwo.png"),
        },
        {
          image: require("@/assets/solution/shopThr.png"),
          bottomTitle: '<span>制定激励规则</br>用利益和规则聚拢分销合伙人</span>',
          bottomContent: '制定激励规则，激励用户进行消费、分享等行为，通过等级管理、团队激励、推广佣金、消费返利等业务功能即可完成社交分销的起盘环节'
        },
      ],
      shopThrList: [
        {
          title: '经营策略',
          content: '行业市场及目标人群分析，深挖需求痛点，制分销方案',
          image: require("@/assets/solution/shopNum5.png"),
        },
        {
          title: '系统工具',
          content: '提供高效且有用的系统及工具，支持定制以及对接原系统',
          image: require("@/assets/solution/shopNum6.png"),
        },
        {
          title: '服务团队',
          content: '专业运营团队陪跑式服务，随时监督和指导，贡献运营建议',
          image: require("@/assets/solution/shopNum7.png"),
        },
        {
          title: '广告资源',
          content: '海量优质广告资源位提供，营销活动精准触达目标客户群',
          image: require("@/assets/solution/shopNum8.png"),
        },
      ],
    };
  },
  methods: {
    // 当鼠标进入元素时触发
    // handleMouseEnter(index) {
    //   // console.log('鼠标进入了元素' + index);
    //   this.industrySelecedIndex = index;
    // },
    // 当鼠标离开元素时触发
    // handleMouseLeave(index) {
    //   // console.log('鼠标离开了元素');
    // },
  },
};
</script>

<style lang="less" scoped>
.floor-shopping {
  width: 100%;
  height: 920px;
  background: #fff;
}
.shop-item{
  width: 380px;
  height: 370px;
  /* margin: auto; */
  background: #F4F5FB;
  border-radius: 6px;
  padding: 48px 40px;
}
.shop-tab-container{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 45px;
  font-size: 22px;
  color: #222222;
  line-height: 65px;
}
.shop-tab-container .active{
  border-bottom: 4px solid #1763FF;
  font-weight: bold;
}
.shop-tab-foreach{
  width: 1200px;
  height: 580px;
  background: #FFFFFF;
  margin: auto;
  border-radius: 6px;
  padding: 40px;
  /* display: flex;
  justify-content: space-between; */
}
.shop-tab-item-left{
  text-align: left;
  width: 1200px;
  margin-bottom: 22px;
}
.shop-tab-item-title{
  font-size: 22px;
  color: #222222;
  font-weight: bold;
  line-height: 22px;
  margin-top: 16px;
  margin-bottom: 10px;
}
.shop-tab-item-content{
  font-size: 16px;
  color: #232323;
  line-height: 22px;
}
.shop-tab-item-right{
  /* width: 1200px; */
  position: relative;
}
.shop-tab-item-right img{
  width: 100%;
  /* margin: auto; */
}
.shop-tab-item-font{
  position: absolute;
  width: 308px;
  left: 8px;
  bottom: 40px;
}
.shop-tab-item-font-title{
  color: #222222;
  font-size: 22px;
  line-height: 32px;
  font-weight: bold;
  text-align: left;
  margin-bottom: 15px;
}
.shop-tab-item-font-cont{
  color: #595859;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
}
.shop-tab-item{
  cursor: pointer;
  box-sizing: border-box;
  width: 34%;
  border-bottom: 1px solid #CADBFF;
}
.shop-item img{
  width: 60px;
  height: 60px;
  /* margin-top: 30px;
  margin-bottom: 18px; */
}
.shop-item-title{
  font-size: 18px;
  color: #222222;
  font-weight: bold;
  margin-bottom: 12px;
}
.shop-item-content{
  /* padding: 0 50px; */
  color: #595859;
  font-size: 14px;
  line-height: 22px;
  height: 66px;
}
.shop-item-content-forEach{
  display: flex;
  justify-content: space-between;
}
.shop-item-forEach-item{
  width: 90px;height:120px;border-radius:6px;background:#fff;padding:15px 15px 0 15px;margin-top: 40px;
}
.shop-item-forEach-font{
  color: #222222;
  font-size: 13px;
  margin-top: 10px;
}
.floorBg{
  background: linear-gradient(180deg, #E3EFFF, #F9FAFF);
}
.floor-shopping .title{
  font-weight: bold; font-size: 32px; color: #222222;padding-top: 80px;margin-bottom: 14px;
}
.floor-shopping .retailForEach{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.floor-shopping-bg .retailForEach{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.shopping-opportunity{
  width: 585px;
  height: 524px;
  background: linear-gradient(180deg, #FAFCFF, #ECF2FF);
  position: relative;
  padding: 35px;
}
.shopping-opportunity img{
  width: 510px;
  height: 305px;
  margin: auto;
  margin-top: 40px;
}
.shopping-opportunity-tips{
  position: absolute;
  left: 37px;
  top: 161px;
  font-size: 16px;
  color: #303133;
  line-height: 20px;
  font-weight: 560;
  text-align: left;
}
.shopping-container-title{
  color: #222222;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 25px;
}
.shopping-container-cont{
  font-size: 14px;
  line-height: 22px;
  color: #333333;
  margin-top: 30px;
  text-align: left;
}
.shopping-Challenge{
  width: 585px;
  height: 524px;
  background: url('../../assets/solution/shopBg.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  padding: 35px 20px;
}
.shopping-Challenge-position{
  position: absolute;
  padding: 12px 20px;
  background: #FFFFFF;
  border-radius: 6px;
  font-size: 14px;
  color: #333333;
}
.shoppingPosition1{
  left: 20px;
  top: 146px;
}
.shoppingPosition2{
  right: 20px;
  top: 214px;
}
.shoppingPosition3{
  left: 20px;
  top: 282px;
}
.shoppingPosition4{
  left: 20px;
  top: 350px;
}
.shopping-item{
  width: 224px;
  height: 200px;
  margin: auto;
  background: linear-gradient(180deg, #FAFCFF, #ECF2FF);
  border-radius: 6px;
}

.shopping-item img{
  width: 40px;
  height: 40px;
  margin-top: 30px;
  margin-bottom: 18px;
}
.shopping-item-title{
  font-size: 18px;
  color: #222222;
  font-weight: bold;
  margin-bottom: 12px;
}
.shopping-item-content{
  /* padding: 0 50px; */
  color: #595859;
  font-size: 14px;
  line-height: 22px;
}
.shopping-item-one{
  width: 380px;
  height: 240px;
  margin: auto;
  background: linear-gradient(180deg, #FAFCFF, #ECF2FF);
  border-radius: 6px;
}

.shopping-item-one img{
  width: 40px;
  height: 40px;
  margin-top: 30px;
  margin-bottom: 18px;
}
.shopping-item-one-title{
  font-size: 18px;
  color: #222222;
  font-weight: bold;
  margin-bottom: 21px;
}
.shopping-item-one-content{
  padding: 0 50px;
  color: #595859;
  font-size: 14px;
  line-height: 22px;
}
.shopping-child-item{
  display: flex;
  text-align: left;
  /* align-items: self-end; */
  margin-bottom: 10px;
}
.shopping-child-item img{
  width: 16px;
  height: 16px;
  margin: 0;
}
.shopping-item-two-font{
  margin-left: 10px;
}
.shopping-item-two-content{
  width: 260px;
  margin: auto;
}
.floor-shopping .industry-container{
  padding-top: 35px;
  width: 1200px;
  margin: auto;
}
.floor-shopping .industry-container img{
  width: 100%;
}

.floorColor{
  background: #F4F5FB;
}
.floor-shopping-bg{
  width: 100%;
  height: 950px;
  background: url('../../assets/solution/floorBg3.png') no-repeat center center;
  background-size: 1920px 100%;
  background-color: #0B4FD1;
  
}
.bg2{
  background: url('../../assets/solution/floorBg3.png') no-repeat;
  background-size: 100% 100%;
  height: 1300px;
}
.shopping-content{
  margin: auto;
  width: 1200px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 40px;
}
.shopping-item-two{
  width: 590px;
  height: 220px;
  padding-top: 55px;
  padding-left: 30px;
  margin-bottom: 20px;
}
.shopping-item-three{
  background: #FFFFFF;
  width: 285px;
  height: 210px;
  border-radius: 6px;
  margin-bottom: 30px;
  padding: 40px;
}
.shopping-item-three img{
  width: 40px;
  height: 40px;
}
.shopping-item-three-title{
  color: #222222;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
  margin-top: 18px;
}
.shopping-item-three-content{
  color: #595859;
  font-size: 14px;
  line-height: 20px;
}
.shopping-two-title{
  text-align: left;
  color: #FFFFFF;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 20px;
}
.shopping-two-content{
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  width: 280px;
  color: #FFFFFF;
}
.floor-shopping-bg .industry-container{
  padding-top: 35px;
  width: 1200px;
  margin: auto;
}
.floor-shopping-bg .industry-container img{
  width: 100%;
}
.floor-shopping-bg  .title{
  font-weight: bold; font-size: 32px; color: #FFFFFF;padding-top: 80px;margin-bottom: 14px;
}
.floor-tab-height{
  height: 1000px;
}
.floor-tab-height840{
  height: 840px;
}
.floor-tab-height750{
  height: 750px;
}
.floor-tab-height700{
  height: 700px;
}
.floor-tab-height600{
  height: 600px;
}
.floor-tab-height950{
  height:950px;
}
.floor-tab-height1000{
  height:1000px;
}
.floor-tab-height1500{
  height:1500px;
}
.floor-tab-height1350{
  height:1350px;
}
.imgHeight470 img{
  height: 470px;
}
.shop-flex-container{
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-top: 45px;
}
.shop-flex-container-item{
  width: 360px;
  height: 640px;
  background: #FFFFFF;
  border-radius: 6px;
}
.shop-flex-container-item img{
  width: 100%;
}
.shop-flex-container-title{
  color: #222222;
  font-size: 20px;
  font-weight: bold;
  margin-top: 25px;
}

</style>
